import { render, staticRenderFns } from "./EditTopic.vue?vue&type=template&id=2ce27d27&"
import script from "./EditTopic.js?vue&type=script&lang=js&"
export * from "./EditTopic.js?vue&type=script&lang=js&"
import style0 from "./EditTopic.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports